import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';


@Injectable()
export class AnaliseService {
  urlObterQuestoes: string;
  codigoModuloContabilidade = 4;
  idPaginaContabilidade = "954";
  analiseAtual: any = null;

  constructor(public http: HttpClient,
    private gestaoPcaService: GestaoPcaService,
    private utilService: UtilService) {
  }

  public obterIdPaginaContabilidade() {
    return this.idPaginaContabilidade;
  }

  //Obter dados da análise horizontal do balanço patrimonial
  public obterBalancoPatrimonialDaAnaliseHorizontal(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "ADCAnaliseHorizontal/balancoPatrimonial?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  //Obter dados da análise horizontal do balanço patrimonial
  public obterBalancoDvpDaAnaliseHorizontal(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "ADCAnaliseHorizontal/balancoDvp?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  //Obter dados da análise vertical do balanço patrimonial
  public obterAnaliseVertical(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "ADCAnaliseVertical/balancoPatrimonial?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterListaAnalises(codModulo): Observable<any> {
    this.urlObterQuestoes = "conta/listarAnalises?idPca=" + this.gestaoPcaService.getPCA().id + "&isAnalista=" + true;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterDadosAnalisePorModulo(codigoAnalise): Observable<any> {
    this.urlObterQuestoes = "ADCAnalise/obterPorModuloAnalise/" + codigoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterDadosAnalisePorTipo(idSecaoPagina): Observable<any> {
    this.urlObterQuestoes = "ADCAnalise/obterPorTipoAnalise/" + idSecaoPagina + "?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarIncluirAnalise(codigoAnalise, dadosAnalise) {
    this.urlObterQuestoes = "ADCAnalise/" + codigoAnalise + "/atualizaCertificado";
    return this.utilService.putJSON(this.urlObterQuestoes, dadosAnalise);
  }

  public submeterAnaliseNoCertificado(codigoAnalise, dadosAnalise) {
    this.urlObterQuestoes = "ADCAnalise/" + codigoAnalise + "/submeterCertificado";
    return this.utilService.putJSON(this.urlObterQuestoes, dadosAnalise);
  }

  // RGN 05
  public obterAnaliseVerticalBalancoPatrimonial(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseVerticalBalancoPatrimonial?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseVerticalBalancoPatrimonial(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseVerticalBalancoPatrimonial?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseVerticalBalancoPatrimonial(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseVerticalBalancoPatrimonial?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  //RGN 02

  public obterAnaliseValidacaoTotalizadorasORC(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseValidacaoTotalizadorasORC?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterAnaliseValidacaoTotalizadorasPAT(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseValidacaoTotalizadorasPAT?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterAnaliseValidacaoTotalizadorasPATSPED(): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseValidacaoTotalizadorasSPEDBP?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterAnaliseValidacaoTotalizadorasDRESPED(): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseValidacaoTotalizadorasSPEDDRE?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterAnaliseValidacaoTotalizadorasDFC(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseValidacaoTotalizadorasDFC?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterAnaliseValidacaoTotalizadorasFIN(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseValidacaoTotalizadorasFIN?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterAnaliseValidacaoTotalizadorasDVP(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseValidacaoTotalizadorasDVP?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  // public obterAnaliseValidacaoContasTotalizadoras(): Observable<any> {
  //   this.urlObterQuestoes = "analiseContabilidade/AnaliseValidacaoTotalizadoras?idPca=" + this.gestaoPcaService.getPCA().id;
  //   return this.utilService.getJSON(this.urlObterQuestoes);
  // }

  public salvarValidacaoContasTotalizadoras(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseVCT?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterValidacaoContasTotalizadoras(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseVCT?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  //RGN 03 

  public obterAnaliseSaldosViradosDemonstrativoFluxoCaixa(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseSaldosViradosDemonstrativoFluxoCaixa?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }
  public obterAnaliseSaldosViradosPatrimonial(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseSaldosViradosPatrimonial?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterAnaliseSaldosViradosPatrimonialSPED(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseSaldosViradosPatrimonialSPED?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public obterAnaliseSaldosViradosOrcamentario(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseSaldosViradosOrcamentario?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }
  public obterAnaliseSaldosViradosFinanceiro(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseSaldosViradosFinanceiro?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }
  public obterAnaliseSaldosViradosDVP(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseSaldosViradosDVP?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseSaldosVirados(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseSaldosVirados?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseSaldosVirados(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseSaldosVirados?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  //RGN 04.1

  public obterAnaliseHorizontalBP(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseHorizontalBalancoPatrimonial?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseHorizontalBP(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseHorizontalBalancoPatrimonial?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseHorizontalBP(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseHorizontalBalancoPatrimonial?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  //RGN 04.2

  public obterAnaliseHorizontalBF(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseHorizontalBalancoFinanceiro?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseHorizontalBF(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseHorizontalBalancoFinanceiro?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseHorizontalBF(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseHorizontalBalancoFinanceiro?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  //RGN 04.3

  public obterAnaliseHorizontalDVP(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseHorizontalBalancoDVP?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseHorizontalDVP(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseHorizontalBalancoDVP?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseHorizontalDVP(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseHorizontalBalancoDVP?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  //RGN 04.4

  public obterAnaliseHorizontalDFC(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseHorizontalBalancoDFC?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseHorizontalDFC(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseHorizontalDFC?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseHorizontalDFC(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseHorizontalDFC?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 06
  public obterContasBancarias(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseContasBancarias?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarContasBancarias(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseContasBancarias";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterContasBancarias(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseContasBancarias";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 07
  public obterSaldosDeclarados(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseSaldosDeclarados?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarSaldosDeclarados(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseSaldosDeclarados";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterSaldosDeclarados(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseSaldosDeclarados";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 08
  public obterAnaliseBalancoSaldoExtratos(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseBalancoSaldoExtratos?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseBalancoSaldoExtratos(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseBalancoSaldoExtratos?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseBalancoSaldoExtratos(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseBalancoSaldoExtratos?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 09
  public obterAnaliseBalancoCaixa(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseBalancoCaixa?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseBalancoCaixa(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseBalancoCaixa?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseBalancoCaixa(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseBalancoCaixa?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 10
  public obterAnaliseExecucaoRestosPagar(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseExecucaoRestosPagar?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseExecucaoRestosPagar(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseExecucaoRestosPagar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseExecucaoRestosPagar(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseExecucaoRestosPagar?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 11
  public obterValoresRestituiveis(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseValoresRestituiveis?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarValoresRestituiveis(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseValoresRestituiveis?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterValoresRestituiveis(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseValoresRestituiveis?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 12
  public obterSaldoEspecie(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseSaldoEmEspecie?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarSaldoEspecie(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseSaldoEmEspecie?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterSaldoEspecie(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseSaldoEmEspecie?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 13.01
  public obterAnaliseExercicioBalancoPatrimonial(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseExercicioBalancoPatrimonial?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseVCEEBalancoPatrimonial(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseExercicioBalancoPatrimonial";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseExercicioBalancoPatrimonial(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseExercicioBalancoPatrimonial";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 13.02
  public obterAnaliseExercicioBalancoFinanceiro(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseExercicioBalancoFinanceiro?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseVCEEBalancoFinanceiro(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseExercicioBalancoFinanceiro";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseVCEEBalancoFinceiro(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseExercicioBalancoFinanceiro";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 13.03
  public obterAnaliseExercicioBalancoDVP(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseExercicioBalancoDVP?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseVCEEBalancoDVP(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseExercicioBalancoDVP";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseVCEEBalancoDVP(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseExercicioBalancoDVP";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 13.04
  public obterAnaliseExercicioFluxoDeCaixa(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseExercicioFluxoDeCaixa?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseVCEEDFC(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseExercicioDFC";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseVCEEDFC(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseExercicioDFC";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  //RGN 14

  public obterAnalisePrevisaoInicialContasAnaliticas(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnalisePrevisaoInicial?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnalisePrevisaoInicialContasAnaliticas(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnalisePrevisaoInicial";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnalisePrevisaoInicialContasAnaliticas(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnalisePrevisaoInicial";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 15
  public obterAnaliseSaldoContasAnaliticas(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/analiseSaldoContasAnaliticas?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseSaldoContasAnaliticas(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseSaldoContasAnaliticas";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseSaldoContasAnaliticas(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseSaldoContasAnaliticas";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 16
  public obterAnaliseReceitasOrdinariasVsVinculadas(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/analiseReceitasOrdinariasVsVinculadas?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseReceitasOrdinariasVsVinculadas(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseReceitasOrdinariasVsVinculadas";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseReceitasOrdinariasVsVinculadas(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseReceitasOrdinariasVsVinculadas";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 17
  public obterTotalRestosPagarProcessados(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/analiseTotalRestosAPagarProcessados?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarTotalRestosPagarProcessados(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseTotalRestosAPagarProcessados";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterTotalRestosPagarProcessados(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseTotalRestosAPagarProcessados";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 18
  public obterTotalRestosPagarNaoProcessados(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseTotalRestosAPagarNaoProcessados?idPca=" + this.gestaoPcaService.getPCA().id+ "&cdTipoAnalise="+ cdTipoAnalise;;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarTotalRestosPagarNaoProcessados(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseTotalRestosAPagarNaoProcessados";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterTotalRestosPagarNaoProcessados(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submterAnaliseTotalRestosAPagarNaoProcessados";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // RGN 19
  public obterAnaliseRestosPagarNaoProcessados(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseRestosPagarNaoProcessados?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseAPagarNaoProcessados(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseAPagarNaoProcessados";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseAPagarNaoProcessados(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseAPagarNaoProcessados";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  // // RGN 20
  public obterAnaliseRestosAPagarLiquidadosDespesa(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseExecucaoRestosAPagarLiquidadosDespesa?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseRestosAPagarLiquidadosDespesa(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseRestosPagarLiquidados";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseRestosAPagarLiquidadosDespesa(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseRestosPagarLiquidados";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  //RGN 21

  public obterAnaliseIndicadores(cdTipoAnalise: string): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/Indicadores?idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise="+ cdTipoAnalise;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseIndicadores(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarIndicadores";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseIndicadores(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterIndicadores";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

//SPED

  public obterAnaliseHorizontalBPSped(): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseHorizontalBalancoPatSPED?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }

  public salvarAnaliseHorizontalBPSped(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/salvarAnaliseHorizontalPatSPED";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public submeterAnaliseHorizontalBPSped(jsonObjeto): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/submeterAnaliseHorizontalPatSPED";
    return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
  }

  public obterAnaliseValidacaoTotalizadorasSPEDBP(): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseValidacaoTotalizadorasSPEDBP?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }


  public obterAnaliseVerticalBalancoPatrimonialSPED(): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/AnaliseVerticalBalancoPatrimonialSPED?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }



  public obterPreviewCertificado(): Observable<any> {
    this.urlObterQuestoes = "analiseContabilidade/obterPreviewCertificado?idPca=" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(this.urlObterQuestoes);
  }
}



// WEBPACK FOOTER //
// ./src/providers/analise-service.ts